import { render } from "./AttributeEditorDialog.vue?vue&type=template&id=51240b4e&ts=true"
import script from "./AttributeEditorDialog.vue?vue&type=script&lang=ts"
export * from "./AttributeEditorDialog.vue?vue&type=script&lang=ts"

import "./AttributeEditorDialog.vue?vue&type=style&index=0&id=51240b4e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__